import React from "react";

export default function RadioButtonComponent(props) {
    const register = props.register;
    return (
        <React.Fragment> 
           
                <h4 className="mt-3 h5"><strong>{props.title}:</strong></h4>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="0" {...register(props.name)} />
                            <span className="ml-1">N/A</span>
                        </div>
                    </label>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="1" {...register(props.name)} />
                            <span className="ml-1">1</span>
                        </div>
                    </label>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="2" {...register(props.name)} />
                            <span className="ml-1">2</span>
                        </div>
                    </label>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="3" {...register(props.name)} />
                            <span className="ml-1">3</span>
                        </div>
                    </label>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="4" {...register(props.name)} />
                            <span className="ml-1">4</span>
                        </div>
                    </label>
                    <label className="mr-3">
                        <div>
                            <input type="radio" value="5" {...register(props.name)} />
                            <span className="ml-1">5</span>
                        </div>
                    </label>

        </React.Fragment>
    )
}